// extracted by mini-css-extract-plugin
module.exports = {"BtnC":"Buttons_BtnC__3C-oX","BtnL":"Buttons_BtnL__jUYfp"};